<div class="table-dropdown" *ngIf="dropDownOption">
  <button class="btn-select-dropdown" [matMenuTriggerFor]="menu" #menuTrigger="matMenuTrigger">
    <span *ngIf="showInvalueText">{{ "reports.show_value_in" | translate }} :</span>
    <span *ngIf="!chartAnalysis">{{
      selectedRadio
      ? ("reports." + selectedRadio | translate)
      : ("reports."+dropDownOption.default | translate) 
      }}</span>
    <span *ngIf="chartAnalysis">
      {{
        selectedRadio
          ? (json_data
              ? (selectedRadio?.value | langtranslate)
              : selectedRadio)
          : dropDownOption.default
      }}
    </span>

    <mat-icon>keyboard_arrow_down</mat-icon>
  </button>
  <mat-menu #menu="matMenu" [xPosition]="langName === 'ar' ? 'after' : 'before'"
    class="grades-menu-selection residential-menu">
    <div (click)="$event.stopPropagation()">
      <h5 *ngIf="dropDownOption.label">
        {{ dropDownOption.label | translate }}
      </h5>
      <mat-radio-group aria-label="Select an option">
        <ng-container *ngFor="let option of dropDownOption.data; let i = index">
          <mat-radio-button   *ngIf="!chartAnalysis" (change)="selectRadioValue(option.id, option.value, menuTrigger)" value="{{ option.id }}"
            [checked]="option.id === dropDownOption.default">{{ "reports." + option.value | translate }}
          </mat-radio-button>
          
          <mat-radio-button *ngIf="chartAnalysis" (change)="selectRadioValue(option.id, option.value, menuTrigger)" value="{{ option.id }}"
            [checked]="option.id === dropDownOption.default">{{ json_data ? (option.value | langtranslate)  : option.value }}
          </mat-radio-button>

        </ng-container>
      </mat-radio-group>
    </div>
  </mat-menu>
</div>
